export enum ImageAspectRatio {
  W16H9 = '16:9',
  W4H3 = '4:3',
  W1H1 = '1:1',
  W32H9 = '32:9',
  W64H9 = '64:9',
  W3H4 = '3:4',
  W9H16 = '9:16',
  W9H32 = '9:32',
}
